import { useSubscription } from '@terminal/stores/use-subscription/useSubscription';
import { useMemo } from 'react';

import { useEarningsInsightsFilter } from './useEarningsInsightsFilter';
import { deduplicateEarningsInsights } from './useEarningsInsightsFilter.utils';

interface UseEarningsInsightsByEarningsIdProps {
  earningsIds: string[];
  isEnabled?: boolean;
}

export const useEarningsInsightsByEarningsId = ({
  earningsIds,
  isEnabled = true,
}: UseEarningsInsightsByEarningsIdProps) => {
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );

  const earningsIdsToFetch =
    isEnabled && !isBasicOrLightUser ? earningsIds : [];

  const { data: earningsInsights, isFetching: isEarningsInsightsFetching } =
    useEarningsInsightsFilter({
      body: { earnings_ids: earningsIdsToFetch },
      isEnabled: earningsIdsToFetch.length > 0,
    });

  const earningsInsightByEarningsId = useMemo(() => {
    const deduplicated = deduplicateEarningsInsights(earningsInsights);
    return new Map(deduplicated.map(insight => [insight.earnings_id, insight]));
  }, [earningsInsights]);

  return { earningsInsightByEarningsId, isEarningsInsightsFetching };
};
